import actionTypes, {
    loadUserActionsTypes,
    loadSearchResultsTypes,
    postSafedSearchTypes,
    postUserActionTypes,
    postFavoritedUserActionTypes,
    unfavoriteUserActionsTypes,
} from "quick-search-bar/action-types"

import * as djangioActionCreators from "shared/djangio/action-creators"

export const fetchUserActions = (uniqueId, query, dataTypes) => (dispatch) =>
    !Userdata.logged_in_as_user
        ? dispatch(
              djangioActionCreators.resourceGetList(
                  DjangIO.app.useractions.models.UserAction,
                  loadUserActionsTypes,
                  {
                      data_type__in: dataTypes,
                      quick_search_recent_searches: query || "",
                  },
                  { uniqueId },
                  true
              )
          )
        : null

export const createUrlForQuickSearch = (query, dataTypes) => {
    const { member, executive, local_member, eu_person, staffer } = DjangIO.app.person.types.PersonType
    let url = `/api/user/quick_search/?query=${query}&data_types=${dataTypes}&highlight=true`

    if (dataTypes[0] === DjangIO.app.models.QuorumDataType.person.value) {
        // need to distinguish between officials and staffers
        url = `${url}&most_recent_person_type__in=${member.value},${executive.value},${local_member.value},${eu_person.value}`
    } else if (dataTypes[0] === DjangIO.app.models.QuorumDataType.staffer.value) {
        url = `${url}&most_recent_person_type__in=${staffer.value}`
    }
    return url
}

export const fetchSearchResults = (uniqueId, query, dataTypes) => (dispatch) => {
    dispatch({ type: loadSearchResultsTypes.start, uniqueId })
    Promise.resolve(
        $.ajax({
            content_type: "application/json",
            data_type: "json",
            url: createUrlForQuickSearch(query, dataTypes),
        })
    )
        .then((response) => dispatch({ type: loadSearchResultsTypes.success, response, uniqueId }))
        .catch((error) => dispatch({ type: loadSearchResultsTypes.fail, error, uniqueId }))
}

export const clearSearchResults = (uniqueId) => ({
    type: actionTypes.CLEAR_SEARCH_RESULTS,
    uniqueId,
})

export const clearUserActions = (uniqueId) => ({
    type: actionTypes.CLEAR_USER_ACTIONS,
    uniqueId,
})

export const registerQuickSearchBar = (uniqueId) => ({
    type: actionTypes.REGISTER,
    uniqueId,
})

export const registerEnumQuickSearchBar = (uniqueId) => ({
    type: actionTypes.REGISTER_ENUM,
    uniqueId,
})

export const updateQuery = (uniqueId, query) => ({
    type: actionTypes.UPDATE_QUERY,
    uniqueId,
    query,
})

export const setFocus = (uniqueId, focused) => ({
    type: actionTypes.SET_FOCUS,
    uniqueId,
    focused,
})

export const setArrowSelectedIndex = (uniqueId, num) => ({
    type: actionTypes.UPDATE_ARROW_INDEX,
    uniqueId,
    num,
})

export const resetArrowSelectedIndex = (uniqueId) => ({
    type: actionTypes.RESET_ARROW_INDEX,
    uniqueId,
})

/**
 * Create a safedsearch with the given data_type and filters.
 * With the newly created safedsearch, create a search_created type of
 * user action with the new safedsearch as a fk.
 *
 *
 * @param  {Object} safedSearchKwargs    [search filters, e.g. { data_type: qdt value, filters:[{ advanced_search: 'albus', ... }] }]
 * @param  {String} options.query        [search bar query (aka the advanced_search, e.g. 'albus')]
 * @param  {Boolean} options.is_favorited [whether or not the user is also asking to mark the new useraction as a favorite]
 * @param  {String} uniqueId            [uniqueId of the search bar calling this function]
 */
export const createSafedSearchAndUserAction =
    (safedSearchKwargs, { query, is_favorited }, uniqueId) =>
    (dispatch) => {
        // don't save recent searches when logged in as user
        if (!Userdata.logged_in_as_user && !Userdata.debug_mode) {
            return dispatch(
                djangioActionCreators.resourcePostList(
                    DjangIO.app.userdata.models.SafedSearch,
                    postSafedSearchTypes,
                    safedSearchKwargs
                )
            ).then((newSavedSearch) =>
                dispatch(
                    djangioActionCreators.resourcePostList(
                        DjangIO.app.useractions.models.UserAction,
                        is_favorited ? postFavoritedUserActionTypes : postUserActionTypes,
                        {
                            action_type: DjangIO.app.useractions.types.UserActionType.search_created.value,
                            user: DjangIO.app.userdata.models.QuorumUser.foreignKey(Userdata.id),
                            current_url: (window && window.location && window.location.href) || "mobile",
                            description: DjangIO.app.models.QuorumDataType.by_value(newSavedSearch.data_type).plural,
                            query,
                            data_type: newSavedSearch.data_type,
                            safedsearch: DjangIO.app.userdata.models.SafedSearch.foreignKey(newSavedSearch.id),
                            is_favorited,
                        },
                        {
                            uniqueId,
                        }
                    )
                )
            )
        }
    }

/**
 * Unfavorite useractions
 * @param  {Array<number | string>} ids [List of UserAction ids]
 * @param  {string}                 uniqueId [unique id of search bar]
 */
export const unfavoriteUserActions = (ids, uniqueId) =>
    djangioActionCreators.resourcePatchList(
        DjangIO.app.useractions.models.UserAction,
        unfavoriteUserActionsTypes,
        ids.map((id) => ({
            resource_uri: DjangIO.app.useractions.models.UserAction.foreignKey(id),
            is_favorited: false,
        })),
        { ids, uniqueId }
    )

/**
 * All the actions used by the simpler, enum quick search bar
 */
export const enumSearchBarActions = {
    registerEnumQuickSearchBar,
    updateQuery,
    setFocus,
    setArrowSelectedIndex,
    resetArrowSelectedIndex,
}
